import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatSelect, MatOption } from '@angular/material';
import { DiscountGroupPersonEntryComponent } from 'src/app/pages/finance/discount-group-person/discount-group-person-entry/discount-group-person-entry.component';
import { ExceptionalCoefficientsService } from 'src/app/services/http/business/ExceptionalCoefficients/exceptional-coefficients.service';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
import { BIDService } from 'src/app/services/common/bid.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
//import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { ICompany } from 'src/app/interfaces/company';
import { IBranch } from 'src/app/interfaces/branch';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { CoursePatternService } from 'src/app/services/http/business/course-pattern/course-pattern.service';
//import { CustomValidators } from 'src/app/shared/customValidators';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { CustomValidators } from 'src/app/shared/customValidators';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { isArray } from 'jquery';
import { HttpHeaders } from '@angular/common/http';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-exceptional-coefficients-entry',
  templateUrl: './exceptional-coefficients-entry.component.html',
  styleUrls: ['./exceptional-coefficients-entry.component.css']
})
export class ExceptionalCoefficientsEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  isOwner: boolean;
  personInfo: any;
  errObject: any;
  form: FormGroup;
  errors = new Array();

  eduPackageList: IEducationPackage;
  levelInfoList = [];
  companyList: ICompany[];
  branchList: IBranch[];
  coursePatternList = [];
  @ViewChild('allSelected') private allSelected: MatOption;
  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private eduPackageService: EducationPackageService,
    private snackBar: SnackBarService,
    private levelInfoService: LevelInfoService,
    private bidService: BIDService,
    private cidService: CIDService,
    private branchService: BranchService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private coursePatternService: CoursePatternService,
    public dialogRef: MatDialogRef<DiscountGroupPersonEntryComponent>,
    private exceptionalCoefficientsService: ExceptionalCoefficientsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log(this.data);

    this.createForm();
    this.checkOwner();
    // this.getCompanyList();
    this.getEduPackage();
    this.getCoursePattern();
  }

  createForm() {
    this.form = this.fb.group({
      Id: [0],
      CompanyEncryptId: [null],
      BranchEncryptId: [null],
      Coefficient: [null, Validators.compose([
        Validators.required, Validators.min(0), Validators.max(20)])],
      LevelInfoId: [null],
      PackageId: [null],
      TimeStart: [null],
      TimeEnd: [null],
      CoursePatternId: [null],
    },
      { validator: CustomValidators.TimeValidator }
    );
    // this.form.controls["ContractNumber"].patchValue(res.IndicatoNumber);
    if (this.data) {
      if (this.data.Id) this.form.controls.Id.setValue(this.data.Id)
      if (this.data.BranchEncryptId) this.form.controls["BranchEncryptId"].patchValue(this.data.BranchEncryptId)
      if (this.data.CompanyEncryptId) this.form.controls["CompanyEncryptId"].patchValue(this.data.CompanyEncryptId)
      if (this.data.Coefficient) this.form.controls["Coefficient"].patchValue(this.data.Coefficient)
      if (this.data.CoursePatternId) this.form.controls["CoursePatternId"].patchValue(this.data.CoursePatternId)
      if (this.data.PackageId) this.form.controls["PackageId"].patchValue(this.data.PackageId)
      if (this.data.TimeStart) this.form.controls["TimeStart"].patchValue(this.data.TimeStart)
      if (this.data.TimeEnd) this.form.controls["TimeEnd"].patchValue(this.data.TimeEnd)
      if (this.data.LevelInfoId) this.form.controls["LevelInfoId"].patchValue(this.data.LevelInfoId)
      if (this.data.CompanyEncryptId) this.form.controls.CompanyEncryptId.setValue(this.data.CompanyEncryptId)
    }
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  togglePerOne() {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }
    if (this.form.controls.LevelInfoId.value.length == this.levelInfoList.length)
      this.allSelected.select();

  }
  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.form.controls.LevelInfoId
        .patchValue([...this.levelInfoList.map(item => item.Id), 0]);
    } else {
      this.form.controls.LevelInfoId.patchValue([]);
    }
  }

  getBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });
  }
  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);

      }
    );
  }
  getLevelInfo(e: MatSelect) {

    this.levelInfoService.getList(e.value).subscribe(
      res => {
        this.levelInfoList = res.DataList;
      },
      err => {
        console.log(err);

      }
    );
  }

  getCoursePattern() {
    this.coursePatternService.getList(0, 0).subscribe(
      res => {

        this.coursePatternList = res.DataList;
      },
      () => {

        this.errorService.transactionError();
      }
    );
  }


  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.getBranchList(e.value);
  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkValidatorForm(control: any): boolean {
    if (
      control['CoursePatternId'] == null &&
      control['TimeStart'] == null &&
      control['LevelInfoId'] == null &&
      control['BranchEncryptId'] == null
    )
      return false;
    else
      return true;

  };
  submit(form: any) {
    this.errors = new Array();

    var levelList = form.LevelInfoId;
    var convertArrtoObject = new Array();
    if (isArray(levelList)) {
      levelList.forEach(x => {
        convertArrtoObject.push({ LevelInfoId: x });
      });
      this.form.controls["LevelInfoId"].setValue(convertArrtoObject);
    }
    else {
      this.form.controls["LevelInfoId"].setValue(form.LevelInfoId);
    }
    if (form.TimeStart && form.TimeStart.length > 5)
      form.TimeStart = form.TimeStart.substring(0, 5);
    //this.form.controls["TimeStart"].patchValue(form.TimeStart.substring(0, 5));
    if (form.TimeEnd && form.TimeEnd.length > 5)
      form.TimeEnd = form.TimeEnd.substring(0, 5);
    //this.form.controls["TimeEnd"].patchValue(form.TimeEnd.substring(0, 5));

    //    this.form.controls["TimeStart"].setValue(form.LevelInfoId);

    // TimeStart: [null],
    // TimeEnd: [null],



    if (this.checkValidatorForm(form)) {
      if (this.data) {
        this.exceptionalCoefficientsService.coefficientsEdit(form).subscribe(() => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.saveSuccess"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
          err => {
            // this.errObject = this.errorService.getError(err);
            // this.param = this.errorService.objectError(this.errObject);
            // this.errors = this.errorService.returnError(err);
            this.errorList = this.errorService.getErrorList(err.error);
          }
        );
      }
      else {
        this.exceptionalCoefficientsService.coefficientsAdd(form).subscribe(() => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.saveSuccess"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
          err => {
            // this.errObject = this.errorService.getError(err);
            // this.param = this.errorService.objectError(this.errObject);
            // this.errors = this.errorService.returnError(err);
            this.errorList = this.errorService.getErrorList(err.error);
          }
        );
      }


    } else {
      this.snackBar.OpenSnackBar(
        this.translate.get("error.isNotUndefinedAllProperties"),
        "ok",
        5000,
        SoundEnum.beep
      );
    }


  }
}
